/**
 * トップページのヒーロー（MainVisualSlider）画像の静的アセット定義。
 *
 * 静的アセット（/img/top/...）を直配信すると約 537KB の webp がそのまま降り、
 * Cloudflare 画像変換（format=auto / リサイズ）にも変換キャッシュにも乗らない。
 * 描画側（MainVisualSlider → OptimizedImage）に生パスと幅を渡し、最適化・preload はすべて
 * OptimizedImage が行う（最適化と preload URL が必ず一致する）。
 */

// ヒーローのフルスクリーン表示に対する変換後の横幅（retina 端末を含めて十分なサイズ）
export const HERO_IMAGE_WIDTH_SP = 1080;
export const HERO_IMAGE_WIDTH_PC = 1920;

/** MainVisualSlider のスライド枚数（_00 〜 _06） */
export const HERO_SLIDE_COUNT = 7;

/**
 * スライド index（0 始まり）の静的アセットパス（生 URL）。
 * 描画側で OptimizedImage に渡して最適化・preload させる。
 */
export const getHeroSlidePath = (index: number, isSP: boolean): string => (isSP ? `/img/top/Wabunka_SP/wabunkaSP_top_0${index}.webp` : `/img/top/Wabunka_PC/wabunkaPC_top_0${index}.webp`);
